import { DimeDetailPageStates } from '@nudool/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { useBreadcrumbLabel } from '../../components/BreadcrumbLabelsContext.js';
import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import { usePermissions } from '../../modules/iam/permissions-context.js';
import { InvoiceDetailSkeleton } from '../../modules/invoices/invoice-detail-skeleton.js';
import { InvoiceDetailView } from '../../modules/invoices/invoice-detail-view.js';
import { useInvoiceDetail } from '../../modules/invoices/use-invoice-detail.js';

// The raw GraphQL error is never shown; it can carry server internals.
const LOAD_ERROR_MESSAGE = 'Something went wrong loading this invoice.';

export const Route = createFileRoute('/invoices/$invoiceId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: InvoiceDetailPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function InvoiceDetailPage() {
  const { invoiceId } = Route.useParams();
  const { permissions } = usePermissions();
  const { invoice, loading, error, refetch, refresh, lines, applications, businessDay } =
    useInvoiceDetail({
      invoiceId,
      canViewPayments: permissions.includes('payment:view'),
    });
  useBreadcrumbLabel(invoiceId, invoice?.invoiceNumber ?? undefined);

  return (
    <DimeDetailPageStates
      data={invoice}
      loading={loading}
      error={error ? { message: LOAD_ERROR_MESSAGE } : null}
      entityLabel="Invoice"
      onRetry={() => void refetch()}
      skeleton={<InvoiceDetailSkeleton />}
    >
      {(loaded) => (
        <InvoiceDetailView
          invoice={loaded}
          lines={lines}
          applications={applications}
          businessDay={businessDay}
          onChanged={() => void refresh()}
        />
      )}
    </DimeDetailPageStates>
  );
}
